import { faker } from '@faker-js/faker/locale/en'
import type { DateTime } from 'luxon'
import type {
  GateTransaction as GETGateTransaction,
  TerminalName,
  TransactionDirection,
} from '~/services/apiClient'
import { getTerminalLabel } from '~/constants'
import { fastParseISO, formatDT, moveDescription } from '~/utils'

export class GateTransaction {
  time: DateTime
  direction: TransactionDirection
  loaded: boolean
  terminal: TerminalName
  chassis_number?: string
  truck_rfid?: string
  drivers_license_number?: string
  truck_license_plate?: string
  extra_data: object | undefined
  constructor(gate_trx: GETGateTransaction, demoMode: boolean) {
    this.time = fastParseISO(gate_trx.time)
    this.direction = gate_trx.direction
    this.loaded = gate_trx.loaded
    this.terminal = gate_trx.terminal
    this.chassis_number = gate_trx.chassis_number
    this.truck_rfid = gate_trx.truck_rfid_number
    this.drivers_license_number = gate_trx.drivers_license_number
    this.truck_license_plate = gate_trx.truck_license_plate_number
    this.extra_data = gate_trx.extra_data

    if (demoMode) {
      // Anonymize PII in demo mode
      if (this.drivers_license_number) {
        this.drivers_license_number = faker.string
          .alphanumeric({ length: 8 })
          .toUpperCase()
      }
      if (this.truck_license_plate) {
        this.truck_license_plate = faker.vehicle.vin().slice(0, 7).toUpperCase()
      }
      if (this.truck_rfid) {
        this.truck_rfid = faker.string
          .alphanumeric({ length: 10 })
          .toUpperCase()
      }
      if (this.chassis_number) {
        this.chassis_number = faker.vehicle.vin().slice(0, 8).toUpperCase()
      }
    }
  }

  get type(): string {
    return moveDescription(this.direction, this.loaded)
  }

  get formattedTime(): string {
    return formatDT(this.time)
  }

  get terminalName(): string {
    return getTerminalLabel(this.terminal)
  }
}
